module.exports = __webpack_public_path__ + "static/the-copernican-revolution-9a781ac7a4c85040d16e23880e311b75.jpg";